import React, { PropsWithChildren } from 'react';

const errorColorTailwind = 'orange';
export const errorBgColorTailwind = 'red-50';

export const Error = <E,>({
  error,
  errorToString,
}: {
  error: E;
  errorToString: (e: E) => string;
}): React.ReactElement => {
  return (
    <>
      <div className={`text-xs text-${errorColorTailwind}`}>
        {errorToString(error)}
      </div>
    </>
  );
};

export const Errors = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>): React.ReactElement => {
  return (
    <>
      <div className={`flex flex-row  ${className ?? ''}`}>
        <div className={`icon-alert text-${errorColorTailwind}`}></div>
        <div className={`flex flex-col ml-1`} style={{ gap: '4px' }}>
          {children}
        </div>
      </div>
    </>
  );
};
